import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { AlertTriangleIcon, ShieldAlertIcon, UsersIcon, ClockIcon } from 'lucide-react';
const incidentData = [{
  day: 'Mon',
  outages: 4,
  theft: 2
}, {
  day: 'Tue',
  outages: 3,
  theft: 5
}, {
  day: 'Wed',
  outages: 7,
  theft: 3
}, {
  day: 'Thu',
  outages: 2,
  theft: 8
}, {
  day: 'Fri',
  outages: 5,
  theft: 4
}, {
  day: 'Sat',
  outages: 8,
  theft: 6
}, {
  day: 'Sun',
  outages: 3,
  theft: 2
}];
const activeIncidents = [{
  id: 'INC-001',
  type: 'Outage',
  location: 'Tembisa Block C',
  affected: 450,
  time: '2 hours ago',
  status: 'Investigating'
}, {
  id: 'INC-002',
  type: 'Theft',
  location: 'Soweto Zone 4',
  affected: 12,
  time: '4 hours ago',
  status: 'Dispatched'
}, {
  id: 'INC-003',
  type: 'Outage',
  location: 'Germiston CBD',
  affected: 1200,
  time: '30 mins ago',
  status: 'Identified'
}, {
  id: 'INC-004',
  type: 'Theft',
  location: 'Boksburg North',
  affected: 1,
  time: '1 day ago',
  status: 'Resolved'
}, {
  id: 'INC-005',
  type: 'Outage',
  location: 'Kempton Park',
  affected: 340,
  time: '5 hours ago',
  status: 'Repairing'
}];
export function OutageDetection() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-1679">
      <div className="mb-8" data-id="element-1680">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1681">
          Outage & Theft Detection
        </h1>
        <p className="text-gray-500" data-id="element-1682">
          Real-time monitoring of power outages and suspected electricity theft.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-1683">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1684">
          <div className="p-3 bg-red-50 text-red-600 rounded-none" data-id="element-1685">
            <AlertTriangleIcon className="w-5 h-5" data-id="element-1686" />
          </div>
          <div data-id="element-1687">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1688">
              Active Outages
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1689">12</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1690">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-1691">
            <ShieldAlertIcon className="w-5 h-5" data-id="element-1692" />
          </div>
          <div data-id="element-1693">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1694">
              Suspected Theft
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1695">45</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1696">
          <div className="p-3 bg-mavis-blue/10 text-mavis-blue rounded-none" data-id="element-1697">
            <UsersIcon className="w-5 h-5" data-id="element-1698" />
          </div>
          <div data-id="element-1699">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1700">
              Affected Customers
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1701">3,420</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1702">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-1703">
            <ClockIcon className="w-5 h-5" data-id="element-1704" />
          </div>
          <div data-id="element-1705">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1706">
              Avg Resolution
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1707">2.4 hrs</p>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200 mb-8" data-id="element-1708">
        <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1709">
          Incidents (Last 7 Days)
        </h2>
        <div className="h-80" data-id="element-1710">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1711">
            <AreaChart data={incidentData} margin={{
            top: 10,
            right: 10,
            left: 0,
            bottom: 0
          }} data-id="element-1712">

              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-1713" />

              <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{
              fill: '#6b7280',
              fontSize: 12
            }} dy={10} data-id="element-1714" />

              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#6b7280',
              fontSize: 12
            }} data-id="element-1715" />

              <Tooltip contentStyle={{
              borderRadius: '0',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-1716" />

              <Legend verticalAlign="top" height={36} data-id="element-1717" />
              <Area type="monotone" dataKey="outages" name="Outages" stroke="#E07020" fillOpacity={0.3} fill="#E07020" data-id="element-1718" />

              <Area type="monotone" dataKey="theft" name="Theft" stroke="#0D4F5C" fillOpacity={0.3} fill="#0D4F5C" data-id="element-1719" />

            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-1720">
        <div className="p-5 border-b border-gray-200 bg-gray-50" data-id="element-1721">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-1722">Active Incidents</h2>
        </div>
        <div className="overflow-x-auto" data-id="element-1723">
          <table className="w-full text-left border-collapse" data-id="element-1724">
            <thead data-id="element-1725">
              <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-1726">
                <th className="p-4 font-medium" data-id="element-1727">ID</th>
                <th className="p-4 font-medium" data-id="element-1728">Type</th>
                <th className="p-4 font-medium" data-id="element-1729">Location</th>
                <th className="p-4 font-medium" data-id="element-1730">Affected Meters</th>
                <th className="p-4 font-medium" data-id="element-1731">Time Detected</th>
                <th className="p-4 font-medium" data-id="element-1732">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1733">
              {activeIncidents.map((inc, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-1734">
                  <td className="p-4 text-sm font-mono text-gray-900" data-id="element-1735">
                    {inc.id}
                  </td>
                  <td className="p-4 text-sm font-medium text-gray-900" data-id="element-1736">
                    {inc.type}
                  </td>
                  <td className="p-4 text-sm text-gray-600" data-id="element-1737">{inc.location}</td>
                  <td className="p-4 text-sm font-mono text-gray-600" data-id="element-1738">
                    {inc.affected}
                  </td>
                  <td className="p-4 text-sm text-gray-500" data-id="element-1739">{inc.time}</td>
                  <td className="p-4" data-id="element-1740">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${inc.status === 'Resolved' ? 'bg-green-100 text-green-800' : inc.status === 'Investigating' ? 'bg-orange-100 text-orange-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-1741">

                      {inc.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}